export const checkPhone = function(num) {
  let regx = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return regx.test(num)
}

export const checkMobile = function(num) {
  let regx = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
  return regx.test(num)
}

export const checkIDNum = function(num) {
  let regx = /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/
  return regx.test(num)
}

export const checkBankNum = function(num) {
  let regx = /^[1-9]\d{9,29}$/
  return regx.test(num)
}

export const checkEmail = function(str) {
  let regx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regx.test(str)
}

export const getIsWxClient = function () {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
  }
  return false;
}

export const checkChinese = function (str) {
  let regx = /^[\u4e00-\u9fa5]+$/;
  return regx.test(str)
}

export const tuominMobile = function (str) {
  let pat=/(\d{3})\d*(\d{4})/
  return str.replace(pat,'$1****$2');
}
export const tuominName = function (str) {
  let length = str.length
  let name = ''
  if (length == 2) {
    name = str[0] + '*'
  } else if (length > 2) {
    name = str[0] + '*'.repeat(length-2) + str[length - 1]
  }
  return name
}
export const tuominIdCard = function (str) {
  return str.replace(/^(.{5})(?:\w+)(.{4})$/, "\$1********\$2")
}